import React from 'react';
import { FormGroup, FormControlLabel, Checkbox, Paper, Typography } from '@mui/material';

const LayerSelector = ({ layers, toggleLayer }) => {
  return (
    <Paper 
      elevation={3} 
      sx={{ 
        position: 'absolute', 
        top: '20px', 
        right: '20px', 
        padding: '10px',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
      }}
    >
      <Typography variant="h6" gutterBottom>
        Layers
      </Typography>
      <FormGroup>
        {layers.map((layer) => (
          <FormControlLabel
            key={layer.id}
            control={
              <Checkbox
                checked={layer.visible}
                onChange={() => toggleLayer(layer.id)}
                name={layer.id}
              />
            }
            label={layer.name}
          />
        ))}
      </FormGroup>
    </Paper>
  );
};

export default LayerSelector;